// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"f99b465a","436":"68e019d7","891":"9c9d4eba","947":"91c69397"}[chunkId] + ".chunk.css";
};